import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const AboutPage = () => {
  return (
    <div className="max-w-2xl mx-auto mt-8 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>About Balaga CRM</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Balaga CRM is a full-featured customer relationship management tool
            built for the Balaga team. It helps you manage contacts, companies,
            deals, and tasks in one place.
          </p>
          <div>
            <p className="font-semibold text-foreground mb-1">Built on</p>
            <p>
              Balaga CRM is built on top of{" "}
              <a
                href="https://github.com/marmelab/atomic-crm"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-foreground"
              >
                Atomic CRM
              </a>{" "}
              by{" "}
              <a
                href="https://marmelab.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-foreground"
              >
                Marmelab
              </a>
              , an open-source CRM built with React Admin and Supabase. We are
              grateful for their work.
            </p>
          </div>
          <div>
            <p className="font-semibold text-foreground mb-1">Tech Stack</p>
            <ul className="list-disc list-inside space-y-1">
              <li>React 19 + TypeScript + Vite</li>
              <li>React Admin + shadcn/ui</li>
              <li>Supabase (PostgreSQL + Auth + Edge Functions)</li>
              <li>Caddy + Docker on AlmaLinux</li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-foreground mb-1">Version</p>
            <p>v1.0.0</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

AboutPage.path = "/about";
